/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * User permission.
 */
export enum CreatorPermission {
    ACCESS_ONLYFANS_PROFILE = 'ACCESS_ONLYFANS_PROFILE',
    REASSIGN_SALES = 'REASSIGN_SALES',
    SEE_STATS = 'SEE_STATS',
    SEE_FAN_OVERVIEW = 'SEE_FAN_OVERVIEW',
    SEE_CHATTER_TRACKING = 'SEE_CHATTER_TRACKING',
    SEE_VAULT_IN_DASHBOARD = 'SEE_VAULT_IN_DASHBOARD',
    MODIFY_ONLINE_MASS_MESSAGES = 'MODIFY_ONLINE_MASS_MESSAGES',
    MODIFY_SETTINGS = 'MODIFY_SETTINGS',
    MODIFY_SHIFT = 'MODIFY_SHIFT',
    MODIFY_SOCIAL_ACCOUNTS = 'MODIFY_SOCIAL_ACCOUNTS',
    CONSOLE_ACCESS = 'CONSOLE_ACCESS',
    FAN_NUMBER_SUPERVISOR = 'FAN_NUMBER_SUPERVISOR',
    MODIFY_FAN_NUMBERING = 'MODIFY_FAN_NUMBERING',
    OF_ADMIN = 'OF_ADMIN',
    OF_PROMOTIONS = 'OF_PROMOTIONS',
    OF_MAKE_POSTS = 'OF_MAKE_POSTS',
    OF_MASS_MESSAGES = 'OF_MASS_MESSAGES',
    OF_SETTINGS = 'OF_SETTINGS',
    OF_STATISTICS = 'OF_STATISTICS',
    OF_DELETE_MEDIA = 'OF_DELETE_MEDIA',
    OF_CARDS_BANK = 'OF_CARDS_BANK',
    OF_TICKETS = 'OF_TICKETS',
    OF_HIDE_CHATS = 'OF_HIDE_CHATS',
    OF_HIDE_MESSAGES = 'OF_HIDE_MESSAGES',
    OF_CLEAR_CHAT = 'OF_CLEAR_CHAT',
    OF_FAN_BLOCKING = 'OF_FAN_BLOCKING',
    OF_LOGOUT = 'OF_LOGOUT',
    OF_DELETE_ACCOUNT = 'OF_DELETE_ACCOUNT',
    OF_EDIT_VAULT = 'OF_EDIT_VAULT',
}
